import { ApiResult, PaginatedResponse, request, safeRequest } from '@synergy/api';
import { noop } from '@synergy/utils';

import { BonusSettlement } from '../models/bonus-settlement';

export class BonusSettlementsOverviewApi {
    constructor(protected baseUrl: string) {}

    public getBonusSettlementsOverview(
        searchParams: URLSearchParams
    ): Promise<ApiResult<PaginatedResponse<BonusSettlement>>> {
        return safeRequest(
            () => request.get(`${this.baseUrl}/bonus-settlements`, { params: searchParams }),
            response => response.data
        );
    }

    public updateBonusSettlement(id: number, payout: number): Promise<ApiResult<BonusSettlement>> {
        return safeRequest(
            () => request.post(`${this.baseUrl}/bonus-settlements/${id}/update-payout`, { payout }),
            response => response.data
        );
    }

    public deleteBonusSettlement(id: number): Promise<ApiResult<BonusSettlement>> {
        return safeRequest(
            () => request.delete(`${this.baseUrl}/bonus-settlements/${id}`),
            response => response.data
        );
    }

    public generateBonusSettlement(year: number, isEmpty: boolean): Promise<ApiResult<void>> {
        return safeRequest(() => request.post(`${this.baseUrl}/bonus-settlements/generate`, { year, isEmpty }), noop);
    }

    public createReclamation(id: number): Promise<ApiResult<void>> {
        return safeRequest(() => request.post(`${this.baseUrl}/bonus-settlements/${id}/create-reclamation`), noop);
    }
}
